import {
    ComponentsProps,
    ComponentsOverrides,
    ComponentsVariants,
    svgIconClasses,
    Theme,
    CheckboxProps,
} from '@mui/material';
import { StyleProps } from './utils/dynamicStyle';

type StyleHelperFunctionProps = StyleProps<CheckboxProps>;

function hoverFocusActiveStyle(props: StyleHelperFunctionProps) {
    const palette =
        props.ownerState?.color && props.theme.palette[props.ownerState?.color]
            ? props.theme.palette[props.ownerState?.color]
            : props.theme.palette.secondary;
    return {
        [`:hover,:active`]: {
            color: palette?.dark,
        },
        color: palette?.main,
    };
}

export const MuiCheckbox: {
    defaultProps?: ComponentsProps['MuiCheckbox'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiCheckbox'];
    variants?: ComponentsVariants['MuiCheckbox'];
} = {
    defaultProps: {
        disableRipple: true,
        size: 'medium',
        color: 'secondary',
    },
    styleOverrides: {
        root: (props) => [
            {
                padding: 0,
                [`& .${svgIconClasses.fontSizeMedium}`]: { fontSize: '2rem' },
            },
            hoverFocusActiveStyle(props),
        ],
    },
    variants: [],
};
